export const VARIA_SLACK_CHANNEL = 'https://equinor.enterprise.slack.com/archives/C092FT0AADN';
